// MARK:- Founder letter mobile slider — center the slot-1 photo (Meghan portrait) on initial layout
// so the slider starts in the partially-scrolled state shown in the mobile Figma. Disabled at the
// xlarge breakpoint where the section becomes the absolute-positioned desktop collage.

const DESKTOP_QUERY = window.matchMedia('(min-width: 1201px)');

const centerSlotOne = (slider) => {
  if (DESKTOP_QUERY.matches) return;
  const target = slider.querySelector('[data-slot="1"]');
  if (!target) return;

  const sliderRect = slider.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const sliderCenter = sliderRect.left + sliderRect.width / 2;
  const targetCenter = targetRect.left + targetRect.width / 2;
  slider.scrollLeft += targetCenter - sliderCenter;
};

const init = () => {
  document.querySelectorAll('.founder-letter__media').forEach((slider) => {
    requestAnimationFrame(() => centerSlotOne(slider));
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
